export function explosion(state, keys) {
  state.exploding = {
    stage: 1,
    keys: keys
  };
  state.dom.redraw();
  setTimeout(function () {
    setStage(state, 2);
    setTimeout(function () {
      return setStage(state, undefined);
    }, 120);
  }, 120);
}
function setStage(state, stage) {
  if (state.exploding) {
    if (stage) state.exploding.stage = stage;else state.exploding = undefined;
    state.dom.redraw();
  }
}